import pEvent from 'p-event';

export async function fileToImage(file: File) {
  const img = new Image();
  const load = pEvent(img, 'load');
  img.src = URL.createObjectURL(file);
  await load;
  return img;
}

// notify
export function successNotify() {
  return this.$notify({
    type: 'success',
    title: this.$t('notify["Success"]').toString(),
    message: '',
  });
}

export function createNotify() {
  return this.$notify({
    type: 'success',
    title: this.$t('notify["Success"]').toString(),
    message: this.$t('notify["Create success"]').toString(),
  });
}

export function updateNotify() {
  return this.$notify({
    type: 'success',
    title: this.$t('notify["Success"]').toString(),
    message: this.$t('notify["Update success"]').toString(),
  });
}

export function deleteNotify() {
  return this.$notify({
    type: 'success',
    title: this.$t('notify["Success"]').toString(),
    message: this.$t('notify["Delete success"]').toString(),
  });
}

export function notifyError(message: string) {
  return this.$notify({
    type: 'error',
    title: this.$t('notify["Error"]').toString(),
    message,
  });
}

export function notifyErrorThrow(message: string) {
  this.$notify({
    type: 'error',
    title: this.$t('notify["Error"]').toString(),
    message,
  });

  throw new Error(message);
}
